// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_Cs5","comment":"styles_comment__ZeXqa"};